var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showNavbarIcon && _vm.isAuthorized)?_c('f7-link',{attrs:{"icon":"far fa-user"},on:{"click":_vm.goToProfile}}):(_vm.showNavbarIcon && !_vm.isAuthorized)?_c('f7-link',{attrs:{"icon":"far fa-sign-in"},on:{"click":_vm.goToAuth}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }